import { StaticQuery, graphql } from 'gatsby';
import React from 'react';

import Link from '../components/Link';

import styles from './Footer.module.scss';
import fbIcon from '../images/facebook.svg';
import igIcon from '../images/instagram.svg';
import scIcon from '../images/soundcloud.svg';
import ytIcon from '../images/youtube.svg';

const SocialItem = ({ link, icon, alt }) => (
  <Link to={link} className={styles.socialItem}>
    <img src={icon} alt={alt} />
  </Link>
);

const FooterTemplate = ({
  facebookLink,
  instagramLink,
  youtubeLink,
  soundcloudLink,
  footerLinks
}) => {
  return (
    <div className={styles.footer}>
      <div className={styles.socialBlock}>
        <div className={styles.socialText}>Follow Labelle</div>
        <div className={styles.socialItems}>
          {facebookLink && (
            <SocialItem link={facebookLink} icon={fbIcon} alt="Facebook icon" />
          )}
          {instagramLink && (
            <SocialItem
              link={instagramLink}
              icon={igIcon}
              alt="Instagram icon"
            />
          )}
          {youtubeLink && (
            <SocialItem link={youtubeLink} icon={ytIcon} alt="Youtube icon" />
          )}
          {soundcloudLink && (
            <SocialItem
              link={soundcloudLink}
              icon={scIcon}
              alt="Soundcloud icon"
            />
          )}
        </div>
      </div>
      {footerLinks && (
        <ul className={styles.links}>
          {footerLinks.map(({ title, url }) => (
            <Link to={url} key={title}>
              {title}
            </Link>
          ))}
        </ul>
      )}
      <div className={styles.copyright}>
        © Labelle {new Date().getFullYear()}
      </div>
    </div>
  );
};

const Footer = () => {
  return (
    <StaticQuery
      query={graphql`
        query FooterQuery {
          items: markdownRemark(frontmatter: { type: { eq: "layout-vars" } }) {
            frontmatter {
              facebookLink
              instagramLink
              youtubeLink
              soundcloudLink
              footerLinks {
                title
                url
              }
            }
          }
        }
      `}
      render={({ items }) => (
        <FooterTemplate
          facebookLink={items.frontmatter.facebookLink}
          instagramLink={items.frontmatter.instagramLink}
          youtubeLink={items.frontmatter.youtubeLink}
          soundcloudLink={items.frontmatter.soundcloudLink}
          footerLinks={items.frontmatter.footerLinks}
        />
      )}
    />
  );
};

export { FooterTemplate, Footer as default };
